export function createRoutes() {
  return [
    {
      path: 'summary',
      name: 'summary',
      component: () => import(/* webpackChunkName: "summary" */ '@/summary/Summary.vue'),
    },
  ];
}

export default {
  createRoutes,
};
